'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'bags-shopping';
var width = 576;
var height = 512;
var aliases = [128717];
var unicode = 'f847';
var svgPathData = 'M160 64l0 32 128 0 0-32c0-35.3-28.7-64-64-64s-64 28.7-64 64zM128 96l0-32c0-53 43-96 96-96s96 43 96 96l0 32 64 0c35.3 0 64 28.7 64 64l0 16-32 0 0-16c0-17.7-14.3-32-32-32L64 128c-17.7 0-32 14.3-32 32l0 224c0 17.7 14.3 32 32 32l80 0 0 32-80 0c-35.3 0-64-28.7-64-64L0 160c0-35.3 28.7-64 64-64l64 0zm96 192l0 160c0 17.7 14.3 32 32 32l256 0c17.7 0 32-14.3 32-32l0-160c0-17.7-14.3-32-32-32l-256 0c-17.7 0-32 14.3-32 32zm-32 0c0-35.3 28.7-64 64-64l256 0c35.3 0 64 28.7 64 64l0 160c0 35.3-28.7 64-64 64l-256 0c-35.3 0-64-28.7-64-64l0-160zm112 16c8.8 0 16 7.2 16 16l0 16c0 35.3 28.7 64 64 64s64-28.7 64-64l0-16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 16c0 53-43 96-96 96s-96-43-96-96l0-16c0-8.8 7.2-16 16-16z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBagsShopping = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;